import jsPDF from "jspdf";
import "jspdf-autotable";
import GemarBg from "../../../images/Gemar-USA-Logo-RGB-POS.png";
const packingSlipPDF = (tableRows, columns, isLandscape, title, printData) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  const left = 14;
  const top = 5;
  const imgWidth = 50;
  const imgHeight = 15;

  const getAddressLine = (address) => {
    return doc.splitTextToSize(address, 90);
  };

  var header = function (data) {
    doc.addImage(GemarBg, "PNG", left, top, imgWidth, imgHeight);
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128);

    doc.text(65, 10, "Invoice");
    doc.text(65, 14, "Gemar USA – Distributor Phone: +1 (786) 7622949.");
    doc.setLineWidth(5);
    // doc.setDrawColor(177, 177, 177);
    // doc.line(10, 15, 290, 15); // horizontal line
    // doc.setLineWidth(0.3);
    // doc.line(5, 15, 5, 20);
  };

  doc.setFontSize(13);
  doc.setFont(undefined, "bold");
  doc.text(left, 30, "Order");
  doc.setFontSize(11);
  doc.setFont(undefined, 400);
  doc.text(left, 35, "Order No");
  doc.text(left, 40, "Order Date");
  doc.text(40, 35, printData.OrderNumber.toString());
  doc.text(40, 40, printData.CreatedDateString);

  doc.setFontSize(13);
  doc.setFont(undefined, "bold");
  doc.text(left, 50, "Buyer");
  doc.setFontSize(11);
  doc.setFont(undefined, 400);
  doc.text(left, 55, printData.CompanyName); //company name

  const billingAddressLines = getAddressLine(printData?.BillingAddress);
  var billingAddressHeight = 62;
  for (var i = 0; i < billingAddressLines.length; i++) {
    doc.text(left, 62 + i * 4, billingAddressLines[i]); //billing address
    billingAddressHeight += 4;
  }
  doc.text(left, billingAddressHeight + 3, printData.BillingCity); //billing city
  doc.text(
    left,
    billingAddressHeight + 9,
    printData.BillingStateName +
      ", " +
      printData.BillingCountryName +
      " " +
      (printData.BillingZipCode ? printData.BillingZipCode.toString() : "")
  ); //zip code number

  /* ******************* Shipping Address Detailas ******************* */
  doc.setFontSize(13);
  doc.setFont(undefined, "bold");
  doc.text(110, 50, "Shipping Address");
  doc.setFontSize(11);
  doc.setFont(undefined, 400);
  doc.text(110, 55, printData.CompanyName);

  const shippingAddressLines = getAddressLine(printData.ShippingAddress);
  var shippingAddressHeight = 62;
  for (var j = 0; j < shippingAddressLines.length; j++) {
    doc.text(110, 62 + j * 4, shippingAddressLines[j]);
    shippingAddressHeight += 4;
  }
  doc.text(
    110,
    shippingAddressHeight + 3,
    printData.ShippingCity ? printData.ShippingCity : ""
  );
  doc.text(
    110,
    shippingAddressHeight + 9,
    printData?.ShippingStateName &&
      printData.ShippingCountryName !== "" &&
      printData.ShippingZipCode
      ? printData.ShippingStateName +
          ", " +
          printData.ShippingCountryName +
          " " +
          (printData.ShippingZipCode
            ? printData.ShippingZipCode.toString()
            : "")
      : ""
  );

  doc.autoTable({
    theme: "grid",
    columns: columns,
    body: tableRows,

    beforePageContent: header,
    margin: {
      top: 22,
    },
    startY:
      shippingAddressHeight < billingAddressHeight
        ? billingAddressHeight + 12
        : shippingAddressHeight + 12,
    headStyles: {
      fillColor: "#00a3da",
      fontSize: 12,
      halign: "center",
    },
    styles: {
      valign: "middle",
    },
  });

  let finalY = doc.lastAutoTable.finalY; // The y position on the page
  doc.setFont(undefined, "bold");
  // doc.text(145, finalY + 6, "Order Total : ");
  // doc.text(170, finalY + 6, printData.GrandTotalStr);
  doc.save(title + ".pdf");
};
export default packingSlipPDF;
